import type {
    AssignedTeamMemberLoanOfficerFragment,
    AssignedTeamMemberLoanProcessorFragment,
    ZHLPersonalizedNextStepState,
} from 'src/services/graphql/generated/graphql';

export enum TeamInformationCardVariant {
    TEAM_ASSIGNED = 'TEAM_ASSIGNED',
    NO_TEAM = 'NO_TEAM',
}

export type TeamMember = AssignedTeamMemberLoanOfficerFragment | AssignedTeamMemberLoanProcessorFragment;

export type AssignedTeamMembersProps = {
    variant: TeamInformationCardVariant;
    teamMembers: TeamMember[];
    personalizedNextStepStage: ZHLPersonalizedNextStepState | null;
    helpHotline: string;
    onCall: (phoneNumber: string, isCallOrText?: boolean) => void;
    onEmail: (email: string) => void;
};
